import { render } from "./DeviceDetailPage.vue?vue&type=template&id=1e65048e"
import script from "./DeviceDetailPage.vue?vue&type=script&lang=js"
export * from "./DeviceDetailPage.vue?vue&type=script&lang=js"

import "./DeviceDetailPage.vue?vue&type=style&index=0&id=1e65048e&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__